import { ChProgressNoteDocument, DeProgressNoteDocument } from "@/modules/patients/types/ProgressNoteDocument"

type FormattedCarePlanSummary = ChProgressNoteDocument["carePlanSummary"] | DeProgressNoteDocument["carePlanSummary"]

type ConcludedCarePlanDocument = NonNullable<FormattedCarePlanSummary> & {
  treatmentPlan: NonNullable<NonNullable<FormattedCarePlanSummary>["treatmentPlan"]>
}

const isConcludedCarePlanDocument = (
  carePlanSummary: FormattedCarePlanSummary,
): carePlanSummary is ConcludedCarePlanDocument =>
  !!(carePlanSummary?.treatmentPlan && carePlanSummary.fileId && carePlanSummary.concludedBy)

export { isConcludedCarePlanDocument }
